import { render, staticRenderFns } from "./questionAndAnswerGame.vue?vue&type=template&id=127b74c4&scoped=true"
import script from "./questionAndAnswerGame.vue?vue&type=script&lang=js"
export * from "./questionAndAnswerGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b74c4",
  null
  
)

export default component.exports